namespace gotoAndPlay {
    export class ProductsFilter {
        element: JQuery;
        hideUrl: boolean;
        ajax;

        orderHash: string;
        filterChangeDebounce: number | null = null;

        constructor(target: JQuery) {
            this.element = target;
            this.hideUrl = $("#hide__url-changes").data("hide") == true;
            this.orderHash = this.element.data("product-order-hash");
            this.init();
        }

        GetURLParameter(sParam): string {
            let sPageURL = window.location.search.substring(1);
            let sURLVariables = sPageURL.split("&");
            for (let i = 0; i < sURLVariables.length; i++) {
                let sParameterName = sURLVariables[i].split("=");
                if (sParameterName[0] == sParam) {
                    return sParameterName[1];
                }
            }

            return "";
        }

        moveHashtag(newString, param): string {
            let reg = new RegExp("[#][^?]*");
            let matchTag = reg.exec(newString);

            if (matchTag !== null) {
                newString = newString.replace(matchTag[0], "");
                newString = newString + matchTag[0];
            }

            return newString;
        }

        queryStringUrlReplacement(url, param, value): string {
            let re = new RegExp("[\\?&]" + param + "=([^&#]*)");
            let match = re.exec(url);
            let delimiter;
            let newString;

            if (match === null) {
                if (value != "") {
                    let hasQuestionMark = /\?/.test(url);
                    delimiter = hasQuestionMark ? "&" : "?";
                    newString = url + delimiter + param + "=" + value;
                }
            } else {
                delimiter = match[0].charAt(0);
                newString = url.replace(re, delimiter + param + "=" + value);
            }

            return newString;
        }

        init(): void {
            this.element.find(".multiselect-dropdown__input").change(() => {
                if (this.filterChangeDebounce) {
                    clearTimeout(this.filterChangeDebounce);
                }

                this.filterChangeDebounce = window.setTimeout(
                    this.handleDropdownChange,
                    500
                );
            });

            this.setFilterState();
        }

        setFilterState(): void {
            const filters = this.GetURLParameter("filters");
            let needUpdate = false;
            filters.split(",").forEach((filter) => {
                const filterElements: JQuery = $(
                    'input[name="' + filter + '"]'
                );
                if (filterElements.length > 0) {
                    filterElements.prop("checked", true);
                    needUpdate = true;
                }
            });

            if (needUpdate) {
                $(this.element.find(".multiselect-dropdown__input")[0]).trigger(
                    "change"
                );
            }
        }

        handleDropdownChange = (): void => {
            this.element.find(".product-list__list").addClass("is-loading");
            const { actives, activeFilters } = this.findActive();
            this.loadPosts(activeFilters);
            this.updateUrl(actives);
        };

        updateUrl(actives: string[]): void {
            let url = this.queryStringUrlReplacement(
                window.location.href,
                "filters",
                actives.join(",")
            );
            url = this.moveHashtag(url, "filters");
            if (!this.hideUrl) {
                history.replaceState({}, "Title", url);
            }
        }

        findActive(): any {
            let activeFilters = [];
            let actives = [];

            let filters = this.element.find(".filter__item");
            filters.each((index, element) => {
                let selection = [];
                $(element)
                    .find("input")
                    .each((index, element) => {
                        if ((element as HTMLInputElement).checked) {
                            actives.push($(element).attr("name"));
                            selection.push((element as HTMLInputElement).value);
                        }
                    });
                activeFilters.push(selection);
            });

            return {
                activeFilters: activeFilters,
                actives: actives,
            };
        }

        loadPosts(ids: string[]): void {
            let priced = $("#calculator").length > 0 ? true : false;
            this.ajax = $.post(ajaxPath, {
                filters: ids,
                action: "filter-posts",
                cat: this.element.find(".js-current-cat-id").val(),
                mod: this.element.find(".js-current-mod").val(),
                id: $("#current-post-id").val(),
                priced: priced,
            });
            this.ajax.then((result) => {
                if (result.hash !== this.orderHash) {
                    this.orderHash = result.hash;
                    this.element.find(".js-products").html(result.data);
                }
            });
            this.ajax.always(() => {
                this.element
                    .find(".product-list__list")
                    .removeClass("is-loading");
            });
        }
    }

    $(document).ready(function() {
        let productListContainers = $('.js-product-list__container');

        if (productListContainers.length > 0) {
            productListContainers.each((index, element) => {
                let productList = new ProductsFilter($(element));
            });
        }

        $('.multiselect-dropdown--check').each((index, element) => {
            let checked = $(element).find('.multiselect-dropdown__input--check:checked').length;

            $(element).find(".multiselect-dropdown__select span").remove();

            if (checked) {
                $(element).find('.multiselect-dropdown__select').append('<span>' + checked + '</span>');
            }
        });
    });
}
